import { Bell } from 'lucide-react';
import imgUrl from '@/assets/logo.png';
import { DealerSelection } from '@/components/DealerSelection';
import { SearchInput } from '@/components/SearchInput';
import { Settings } from '@/components/Settings';

export function GlobalTopNav() {
  return (
    <div className="h-13 bg-[#2d2d2d] text-white flex items-center justify-between px-4 border-b border-[#1a1a1a]">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <img src={imgUrl} alt="International Logo" className="h-6 w-auto" />
          <span className="font-semibold hidden sm:inline">
            Maintenance Monitor
          </span>
          <span className="font-semibold inline sm:hidden">MM</span>
        </div>
        <div className="h-6 w-px bg-gray-600"></div>

        <DealerSelection />
      </div>

      <div className="flex items-center gap-3">
        <SearchInput />
        <button
          type="button"
          className="hidden w-8 h-8 items-center justify-center hover:bg-[#3d3d3d] rounded relative"
        >
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
        <Settings />
      </div>
    </div>
  );
}
